import { render } from "./material-apoio2.vue?vue&type=template&id=ee7f76a4"
import script from "./material-apoio2.vue?vue&type=script&lang=js"
export * from "./material-apoio2.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__